import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faHSquare, faQrcode } from '@fortawesome/free-solid-svg-icons';
import ETicketSVG from '../../images/eTicket.svg';
import MobileTransfer from '../../images/mobileTransfer.svg';
import EventNote from '../../images/eventNote.svg';
import { isDef, isUndef } from '../../shared/utils/validations';

const flashIcon = {
  position: 'absolute',
  right: '38%',
  top: '4px',
  fontWeight: 'bold',
  marginLeft: '5px',
};
const marginLeft = {
  marginLeft: '5px',
};
const imgStyles = {
  height: '14px',
  width: '14px',
  marginLeft: '5px',
};
const PUBLIC_NOTE = 'PublicNote';

/**
 *  Object with each icon registered
 */
const svgIconsDeliveryMethod = {
  Hard: <FontAwesomeIcon style={marginLeft} icon={faHSquare} />,
  Flash: (
    <span>
      <FontAwesomeIcon icon={faBolt} />
      <Typography style={flashIcon}>F</Typography>
    </span>
  ),
  'E-Tickets': <img alt="E-Tickets" style={marginLeft} src={ETicketSVG} />,
  'Mobile Transfer': <img alt="E-Tickets" src={MobileTransfer} style={imgStyles} />,
  'Mobile QR': <FontAwesomeIcon style={marginLeft} icon={faQrcode} />,
  PublicNote: <img alt="E-Tickets" src={EventNote} style={imgStyles} />,
};

const HoverIcons = ({ iconsToShow }) => (
  <div style={{ display: 'inline-flex' }}>
    {iconsToShow
      .filter(icon => isDef(svgIconsDeliveryMethod[icon.name]))
      .map(iconFiltered => (
        <Tooltip title={iconFiltered.text} placement="top" key={iconFiltered.name}>
          {svgIconsDeliveryMethod[iconFiltered.name]}
        </Tooltip>
      ))}
  </div>
);

HoverIcons.propTypes = {
  iconsToShow: PropTypes.array.isRequired,
};

const HoverIconsBuilder = ({ value, data }) => {
  if (isUndef(value) && isUndef(data)) {
    return null;
  }
  const iconsArray = [];
  if (isDef(svgIconsDeliveryMethod[value])) {
    iconsArray.push({ name: value, text: value });
  }
  if (data.public_notes) {
    iconsArray.push({ name: PUBLIC_NOTE, text: data.public_notes });
  }
  return <HoverIcons iconsToShow={iconsArray} />;
};

HoverIconsBuilder.propTypes = {
  value: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default HoverIconsBuilder;
